"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.back = exports.push = exports.listen = void 0;
const loc = __importStar(require("./location"));
var location_1 = require("./location");
Object.defineProperty(exports, "listen", { enumerable: true, get: function () { return location_1.listen; } });
const push = (location, { replace } = {}) => {
    loc.update(typeof location === 'string' ? loc.parse(location) : location);
    history[replace ? 'replaceState' : 'pushState'](null, '', loc.stringify());
};
exports.push = push;
const back = () => {
    history.back();
};
exports.back = back;
window.addEventListener('popstate', () => {
    loc.update(Object.assign({ search: '', hash: '' }, loc.parse(location.href.slice(location.origin.length))));
});
